import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ToasterService } from '@abp/ng.theme.shared';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { WaitTimePredictionSettingsService } from '../proxy/wait-time-prediction-settings.service';

@Component({
  selector: 'lc-wait-time-prediction-settings',
  templateUrl: './wait-time-prediction-settings.component.html',
  styleUrls: ['./wait-time-prediction-settings.component.scss'],
})
export class WaitTimePredictionSettingsComponent implements OnInit {
  form: UntypedFormGroup;
  isInitialized: boolean;
  loading: boolean;
  settings: any = {};

  constructor(
    private waitTimePredictionSettingsService: WaitTimePredictionSettingsService,
    private toaster: ToasterService,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit() {
    this.waitTimePredictionSettingsService.getSettings().subscribe((settings: any) => {
      this.settings = settings;
      this.isInitialized = true;
      this.buildForm();
    });
  }

  buildForm() {
    const {
      enableWaitTimePredictionMessage,
      averageAgentChatDurationForSingleAgent,
      averageFirstResponseTimeForSingleAgent,
    } = this.settings;
    this.form = this.fb.group({
      enableWaitTimePredictionMessage: [enableWaitTimePredictionMessage, []],
      averageAgentChatDurationForSingleAgent: [
        averageAgentChatDurationForSingleAgent || 1,
        [Validators.min(1), Validators.max(3600)],
      ],
      averageFirstResponseTimeForSingleAgent: [
        averageFirstResponseTimeForSingleAgent || 1,
        [Validators.min(1), Validators.max(3600)],
      ],
    });

    this.form.get('enableWaitTimePredictionMessage').valueChanges.subscribe(isEnabled => {
      this.updateFormValidators(isEnabled);
    });

    this.updateFormValidators(enableWaitTimePredictionMessage);
  }

  save() {
    if (!this.form.valid) {
      return;
    }

    const settings: any = {
      ...this.form.value,
    };

    this.loading = true;
    this.waitTimePredictionSettingsService
      .updateSettings(settings)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(() => this.toaster.success('AbpSettingManagement::SuccessfullySaved', null));
  }

  private updateFormValidators(isEnabled: boolean) {
    const avgChatCtrl = this.form.get('averageAgentChatDurationForSingleAgent');
    const avgRespCtrl = this.form.get('averageFirstResponseTimeForSingleAgent');

    if (isEnabled) {
      avgChatCtrl.addValidators(Validators.required);
      avgRespCtrl.addValidators(Validators.required);
    } else {
      avgChatCtrl.removeValidators(Validators.required);
      avgRespCtrl.removeValidators(Validators.required);
    }
    avgChatCtrl.updateValueAndValidity();
    avgRespCtrl.updateValueAndValidity();
  }
}
